import React from "react";

export const Gap5 = props => <Gap {...props} size={5} />;
export const Gap10 = props => <Gap {...props} size={10} />;
export const Gap20 = props => <Gap {...props} size={20} />;
export const Gap30 = props => <Gap {...props} size={30} />;
export const Gap50 = props => <Gap {...props} size={50} />;

export const Gap = props => {
    return (
        <div
            {...props}
            className={`gap ${props.className}`}
            style={{
                width: props.size,
                height: props.size,
                flexShrink: 0,
            }}
        />
    );
};

export const FlexSpacer = props => {
    return <div style={{ flexGrow: 2 }}>{props.children}</div>;
};

